export default __webpack_public_path__ + "static/media/图标.1f837f60.jpg";